module.exports = __webpack_public_path__ + "static/img/vip_shenji.7afa057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip_shenji.png
// module id = S/FP
// module chunks = 0